export default __webpack_public_path__ + "static/media/photo--lg--chris-3.03fb6980.jpg";